import styled from 'styled-components';
import { Accordion, Divider, getSpacingToken, getTextTokenPreset, getToken, ListItem } from '@optimus-web/core';
import { AccordionProps } from '@optimus-web/core/src/Accordion/Accordion';

export const SummaryAccordion = styled<React.ComponentType<AccordionProps>>(Accordion)`
    button {
        color: ${getToken('textStaticSecondary')} !important;
    }
`;

export const StyledListItem = styled(ListItem)`
    ${ListItem.SecondaryTextElement} {
        color: ${getToken('textStaticTertiary')};
        ${getTextTokenPreset('bodySmall')};
        height: 100%;
    }
`;

export const StyledDivider = styled(Divider)`
    padding-left: ${getSpacingToken('200')}px;
    padding-right: ${getSpacingToken('200')}px;
`;
